import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { Project } from '@/features/projects/types';
import { PortfolioSummaryForm, PortfolioSummarySubmitFields } from './portfolio-summary-form-new';

export type PortfolioSummaryDrawerProps = {
  readonly formId: string;
  readonly project: Project;
  readonly isOpen: boolean;
  readonly onSubmit: (item: any, description?: string) => void;
  readonly onClose: () => void;
};

export function PortfolioSummaryDrawer({ formId, project, isOpen, onSubmit, onClose }: PortfolioSummaryDrawerProps) {
  const { t } = useTranslation(['projects']);
  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Portfolio Summary')} open={isOpen} onClose={onClose} footer={footer}>
      <PortfolioSummaryForm
        id={formId}
        project={project}
        onSubmit={(data: PortfolioSummarySubmitFields) => onSubmit({portfolio_summary: [data]}, t('Portfolio Summary has been updated'))}
      />
    </Drawer>
  );
}
